module.exports = __webpack_public_path__ + "img/scene2copy02.e8a63068.png";